import { Button, makeStyles } from '@material-ui/core';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

import callApi from '../../utils/callApi';
import { TEMPTED_BACKEND } from '../../constants/apiUrls/apiUrls';
import './LiveEvents.css';
import GroupShowStore from '../../store/GroupShowStore';
import { UserContext } from '../../context';
import ContextualJoinOverlay from '../generalComponents/ContextualJoinOverlay/ContextualJoinOverlay';
import { getAnchorPortalCampaign } from '../App/services';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader

import PrivateContent from '../TrendingSection/PrivateContent';
import { buildAnchorLink, createHeaders } from '../../utils/helpers';
import { observer } from 'mobx-react';
import AnchorStore from '../../store/AnchorStore';


const LiveEvents = ({ history }) => {
  const [anchorsLive, setAnchorsLive] = useState();
  const [anchorModal, setAnchorModal] = useState({});
  const [nnLive, setNnLive] = useState();
  const [anchorRecording, setAnchorRecording] = useState();
  const [recentUpload, setRecentUpload] = useState();
  const user = useContext(UserContext);
  const refreshInterval = 10000;
  let anchorId;
  let anchorShortUrl;
  
  const useStyles = makeStyles((theme) => {

    return {
      btn: {
        position: 'absolute',
        zIndex: '100',
        backgroundColor: '#AC020A',
        color: '#fff',
        borderRadius: '50px',
        width: 'auto',
        textAlign: 'center',
        height: '35px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '14px',
        padding: '0 15px',
        whiteSpace: 'nowrap',
        margin: '15px 0',
        overflow: 'hidden',
        outline: 'none',
        border: 'none',
        textDecoration: 'none',
        '&:hover': {
          backgroundColor: '#AC020A',
          color: '#fff',
        },
        '&:focus': {
          outline: '0',
          boxShadow: 'none',
          textDecoration: 'none',
          color: '#fff',
        },
        '&:active': {
          textDecoration: 'none',
          color: '#fff',
        },
        [theme.breakpoints.down('sm')]: {
          fontSize: '16px',
          height: '40px',
          margin: '18px 0',
        },
      },
    };
  });

  const classes = useStyles();

  const {
    groupShowParticipant: {
      anchorDetails,
      isFromTempted,
    },
  } = GroupShowStore;

  const redirectToSubscribePage = useCallback(async (anchorUsername) => {
    if (isFromTempted) {
      window.open(`https://tempted.com/profile/${anchorDetails.nickname}`);
    } else {
      const response = await GroupShowStore.getAnchorByUsername(anchorUsername);
      if (response.data) {
        const { name } = response.data.data;
        anchorId = response.data.data.id;

        const anchorName = name.toLowerCase().split(' ').join('-');
        anchorShortUrl = `naked-news-anchor-${anchorName}-a${anchorId}`;

        history.push(`/${anchorShortUrl}`);
      }
    }
  }, [isFromTempted, anchorDetails]);

  const toggleContextualJoinOverlay = (anchorInfo) => {
    !anchorModal.showModal ? setAnchorModal({
      anchorId: anchorInfo.id,
      anchorShortUrl: `naked-news-anchor-${anchorInfo.name.toLowerCase().split(' ').join('-')}-a${anchorInfo.id}`,
      showModal: true,
    }) : setAnchorModal({ showModal: false });
  };

  const getShortUrl = (anchor) => {
    const anchorID = anchor.temptationId || anchor.anchorId;
    const anchorData = AnchorStore.getAnchorData(anchorID);

    return `${buildAnchorLink(anchorData, '?filter=fanzone')}`;

  };

  const checkIfSubscribed = (anchorInfo) => {
    if (user?.authenticated) {
      const isSubscribedToAnchor = user?.user?.account?.anchorSubscriptions?.
        find((anchor) => anchor?.anchorName === anchorInfo?.name);

      if (isSubscribedToAnchor) {
        window.location.href = getShortUrl(anchorInfo);
      } else {
        toggleContextualJoinOverlay(anchorInfo);
      }
    } else {
      redirectToSubscribePage(anchorInfo.username);
    }
  };

  const checkIfLive = () => {
    const url = `${TEMPTED_BACKEND}/rest/v1/onlineAnchors?importedOnly=true`;
    callApi(url, 'get', null, null, createHeaders(), null, null, false).then((res) => {
      if (res.data.length) {
        if (res.data.find((anchor) => anchor.id === 241)) {
          setNnLive(res.data.find((anchor) => anchor.id === 241));
          setAnchorsLive(res.data.filter((anchor) => anchor.id !== 241));
          getRecentUpload();
        } else {
          setAnchorsLive(res.data);
          setNnLive();
        }
      } else {
        fetchRecentStreams();
        setNnLive();
        setAnchorsLive();
      }
    });
  };


  const fetchRecentStreams = () => {
    callApi(`${TEMPTED_BACKEND}/rest/v1/mostRecentStreams?limit=10&importedOnly=true`, 'get', null, null, createHeaders(), null, null, false).then((res) => {
      if (!anchorRecording) {
        setAnchorRecording((prev) => prev || res.data[0]);
      }
    });
  };

  const getRecentUpload = () => {
    callApi(`${TEMPTED_BACKEND}/rest/v1/anchor/videos-galleries?offset=0&limit=1`, 'get', null, null, createHeaders(), null, null, false).then((res) => {
      setRecentUpload(res.data.itemList[0]);
    });
  };

  const hasSubscription = (anchorInfo) => !!(user.authenticated && user.user.account.anchorSubscriptions.length && user.user.account.anchorSubscriptions.find((anchor) => anchor.anchorName === anchorInfo.anchorName));

  useEffect(() => {
    checkIfLive();
    fetchRecentStreams();
    getRecentUpload();
    AnchorStore.setAnchors();

    const interval = setInterval(() => {
      checkIfLive();
    }, refreshInterval);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="live-events-container">

      {nnLive ? (
        <Carousel autoPlay={true} infiniteLoop={true} interval={8000} showIndicators={false} showStatus={false} showThumbs={false}>
          <div>
            <div className="live-status">
              <FiberManualRecordIcon htmlColor="lime" />
              <h3 className="live-title">Live Now</h3>
            </div>

            {!nnLive.partyShowPartner ? (
              <>
                <a className="clickable-slide" href="/live">
                  <div className="carousel-slide">
                    <Button className={classes.btn}>JOIN NAKED NEWS LIVE NOW!</Button>
                    <img alt={nnLive.name} className="nnLive-image" src={nnLive.image || nnLive.biopic} />
                  </div>
                </a>

                <div className="anchor-status">
                  <h3 className="live-title">{nnLive.status && nnLive.status.length ? nnLive.status : 'Naked News is having a live show now. Check it out!'}</h3>
                </div>
              </>
            ) : (
              <>
                <a className="clickable-slide" href="/live">
                  <div className="carousel-slide">
                    <Button className={classes.btn}>JOIN PARTY SHOW NOW!</Button>
                    <img alt={nnLive.name} className="nnLive-image nnLive-image-party" src={nnLive.image} />
                    <img alt={nnLive.name} className="nnLive-image nnLive-second-image-party" src={nnLive.partyShowPartner.biopic || nnLive.partyShowPartner.image} />
                  </div>
                </a>

                <div className="anchor-status">
                  <h3 className="live-title">{`NN Live and ${nnLive.partyShowPartner.name || nnLive.partyShowPartner.nickname} are live in party show. Click the button to join them!`}</h3>
                </div>
              </>
            )}
          </div>

          {anchorsLive && (anchorsLive.map((anchor) => (
            <div key={anchor.id}>
              <div className="live-status">
                <FiberManualRecordIcon htmlColor="lime" />
                <h3 className="live-title">Live Now</h3>
              </div>

              <a className="clickable-slide" onClick={() => checkIfSubscribed(anchor)}>
                <div className="carousel-slide">
                  <Button className={classes.btn}>JOIN {anchor.name} NOW!</Button>
                  <img alt={anchor.nickname} className="nnLive-image" src={anchor.biopic || anchor.image} />
                </div>
              </a>

              <div className="anchor-status">
                <h3 className="live-title">{anchor.status && anchor.status.length ? anchor.status : `${anchor.name} is having a live show now. Check it out!`}</h3>
              </div>
            </div>
          )))}

          {anchorRecording && (<>
            <div className="live-status">
              <h3 className="live-title">Last Live Show</h3>
            </div>

            <a className="clickable-slide" href={`/${getShortUrl(anchorRecording)}`}>
              <div className="carousel-slide">
                <Button className={classes.btn} >JOIN {anchorRecording.name} NOW!</Button>
                <img alt={anchorRecording.nickname} className="nnLive-image" src={anchorRecording.biopic} />
              </div>
            </a>

            <div className="anchor-status">
              <h3 className="live-title">{`${anchorRecording.name} was recently in a live show. Click the button to see her shows!`}</h3>
            </div>
          </>
          )}

          {recentUpload && <>
            <div className="live-status">
              <h3 className="live-title">Newest Content</h3>
            </div>

            <div className="carousel-slide private-content-slide">
              <PrivateContent anchorId={recentUpload.anchorId} anchorShortUrl={getShortUrl(recentUpload)} galleriesAndVideos={Array(recentUpload)} needClasses={true} subscribed={hasSubscription(recentUpload)} user={user} videoClass={true} />
            </div>

            <div className="anchor-status">
              <h3 className="live-title">{`${recentUpload.anchorName} has recently added new content. Click the button to check it out!`}</h3>
            </div>
          </>}
        </Carousel>
      ) : anchorsLive ? (
        <Carousel autoPlay={true} infiniteLoop={true} interval={8000} showIndicators={false} showStatus={false} showThumbs={false}>
          {anchorsLive && (anchorsLive.map((anchor) => (
            <div key={anchor.id}>
              <div className="live-status">
                <FiberManualRecordIcon htmlColor="lime" />
                <h3 className="live-title">Live Now</h3>
              </div>

              <a className="clickable-slide" onClick={() => checkIfSubscribed(anchor)}>
                <div className="carousel-slide">
                  <Button className={classes.btn} onClick={() => checkIfSubscribed(anchor)}>JOIN {anchor.name} NOW!</Button>
                  <img alt={anchor.nickname} className="nnLive-image" src={anchor.biopic || anchor.image} />
                </div>
              </a>

              <div className="anchor-status">
                <h3 className="live-title">{anchor.status && anchor.status.length ? anchor.status : `${anchor.name} is having a live show now. Check it out!`}</h3>
              </div>
            </div>
          )))}

          {anchorRecording && (<>
            <div className="live-status">
              <h3 className="live-title">Last Live Show</h3>
            </div>

            <a className="clickable-slide" href={`/${getShortUrl(anchorRecording)}`}>
              <div className="carousel-slide">
                <Button className={classes.btn}>JOIN {anchorRecording.name} NOW!</Button>
                <img alt={anchorRecording.nickname} className="nnLive-image" src={anchorRecording.biopic} />
              </div>
            </a>

            <div className="anchor-status">
              <h3 className="live-title">{`${anchorRecording.name} was recently in a live show. Click the button to see her shows!`}</h3>
            </div>
          </>
          )}
          {recentUpload && <>
            <div className="live-status">
              <h3 className="live-title">Newest Content</h3>
            </div>

            <div className="carousel-slide private-content-slide">
              <PrivateContent anchorId={recentUpload.anchorId} anchorShortUrl={getShortUrl(recentUpload)} galleriesAndVideos={Array(recentUpload)} needClasses={true} subscribed={hasSubscription(recentUpload)} user={user} videoClass={true} />
            </div>

            <div className="anchor-status">
              <h3 className="live-title">{`${recentUpload.anchorName} has recently added new content. Click the button to check it out!`}</h3>
            </div>
          </>}
        </Carousel>
      ) : anchorRecording && (
        <Carousel autoPlay={true} infiniteLoop={true} interval={8000} showIndicators={false} showStatus={false} showThumbs={false}>
          <>
            <div className="live-status">
              <h3 className="live-title">Last Live Show</h3>
            </div>

            <a className="clickable-slide" href={`/${getShortUrl(anchorRecording)}`}>
              <div className="carousel-slide">
                <Button className={classes.btn}>JOIN {anchorRecording.name} NOW!</Button>
                <img alt={anchorRecording.nickname} className="nnLive-image" src={anchorRecording.biopic} />
              </div>
            </a>

            <div className="anchor-status">
              <h3 className="live-title">{`${anchorRecording.name} was recently in a live show. Click the button to see her shows!`}</h3>
            </div>
          </>

          {recentUpload && (<>
            <div className="live-status">
              <h3 className="live-title">Newest Content</h3>
            </div>

            <div className="carousel-slide private-content-slide">
              <PrivateContent anchorId={recentUpload.anchorId} anchorShortUrl={getShortUrl(recentUpload)} galleriesAndVideos={Array(recentUpload)} needClasses={true} subscribed={hasSubscription(recentUpload)} user={user} videoClass={true} />
            </div>

            <div className="anchor-status">
              <h3 className="live-title">{`${recentUpload.anchorName} has recently added new content. Click the button to check it out!`}</h3>
            </div>
          </>)}
        </Carousel>
      )
      }

      {anchorModal.showModal && <ContextualJoinOverlay
        anchorId={anchorModal.anchorId}
        anchorPortalCampaign={getAnchorPortalCampaign}
        anchorShortUrl={anchorModal.anchorShortUrl}
        closeContextualOverlay={toggleContextualJoinOverlay}
        history={history}
        showOverlay={anchorModal.showModal}
        user={user}
      />}
    </div>
  );
};

export default observer(LiveEvents);
